import { render, staticRenderFns } from "./categorySetting.vue?vue&type=template&id=f61fffac"
import script from "./categorySetting.vue?vue&type=script&lang=js"
export * from "./categorySetting.vue?vue&type=script&lang=js"
import style0 from "./categorySetting.vue?vue&type=style&index=0&id=f61fffac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports